import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

export default function PaymentConfirmationPage() {
  const [params] = useSearchParams()
  const cancelled = params.get('status') === 'cancelled'
  const hasSession = Boolean(params.get('session_id'))

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 520 }}>
        <div className="brand">RE<span>BOUND</span></div>
        <h1>{cancelled ? 'Payment not completed' : 'Payment received'}</h1>
        <p className="text-muted" style={{ lineHeight: 1.6 }}>
          {cancelled
            ? 'No payment was taken. You can close this page and contact the workshop if you need a new payment link or want to pay another way.'
            : hasSession
              ? 'Thanks. Stripe has securely processed your payment. The workshop will receive confirmation and update your job shortly.'
              : 'Thanks. If you have just paid, Stripe will securely confirm the payment with the workshop shortly.'}
        </p>
        <div className="alert alert-info" style={{ marginTop: 16 }}>
          For privacy, this confirmation page does not show job, customer, bike, or component details.
        </div>
        <Link className="btn btn-primary" to="/login" style={{ marginTop: 18 }}>
          Go to Rebound
        </Link>
      </div>
    </div>
  )
}
